import React, { Fragment } from 'react';
import styles from './styles.module.scss';
import mainStyles from '../../styles.module.scss';
import classNames from 'classnames';
import { CCMClientSettingsConfig } from '../../config/CCMClientSettingsConfig';

export const ClientCodeStatusComponent = ({
  clientCodeStatus,
  clientStatusDisplayText,
  clientCode,
  isImporting,
  handleYesBtn,
  handleNoBtn,
  error = null
}) => {
  const renderStatus = () => (
    <Fragment>
      {renderClientStatusDisplayText(clientStatusDisplayText)}
      {clientCode ? <p>{`Client code: ${clientCode}`}</p> : null}
    </Fragment>
  );

  const renderClientStatusDisplayText = text => {
    return <p id="clientStatusDisplayText">{text}</p>;
  };

  const {
    STATE_CODES: {
      EXISTS_IN_SF_NOT_ADMIN,
      CODE_IMPORTED_SUCCESFULLY,
      CODE_ALREADY_IMPORTED,
      CODE_NOT_IN_ADMIN_SF,
      CODE_IS_NOT_NET_NEW,
      MULTIPLE_OVERVIEWS_EXIST,
      SALESFORCE_CONNECTION_ERROR,
      CLIENT_IS_COHORT_SCENARIO,
      ALL_OVERVIEWS_INACTIVE
    }
  } = CCMClientSettingsConfig;

  const renderClientCodeComponent = () => {
    switch (clientCodeStatus) {
      case EXISTS_IN_SF_NOT_ADMIN:
        return (
          <Fragment>
            {renderStatus()}
            {isImporting && <p>Importing...</p>}
            <div className={classNames('flex', styles.actionBtnContainer, {})}>
              <button
                className={classNames('mr-1', mainStyles.regularBtn, { [styles.actionBtn]: true })}
                onClick={handleYesBtn}
                disabled={isImporting}
              >
                Yes
              </button>
              <button
                className={classNames(mainStyles.regularBtn, { [styles.actionBtn]: true, [styles.searchNoBtn]: true })}
                onClick={handleNoBtn}
                disabled={isImporting}
              >
                No
              </button>
            </div>
          </Fragment>
        );
      case CODE_IMPORTED_SUCCESFULLY:
        return (
          <Fragment>
            {renderClientStatusDisplayText(clientStatusDisplayText)}
            <ClientCodeComponent text={clientCode} />
          </Fragment>
        );
      case CODE_NOT_IN_ADMIN_SF:
      case CODE_IS_NOT_NET_NEW:
      case MULTIPLE_OVERVIEWS_EXIST:
      case SALESFORCE_CONNECTION_ERROR:
      case CLIENT_IS_COHORT_SCENARIO:
      case ALL_OVERVIEWS_INACTIVE:
        return <Fragment>{renderClientStatusDisplayText(clientStatusDisplayText)}</Fragment>;
      case CODE_ALREADY_IMPORTED:
        return (
          <Fragment>
            <ClientCodeComponent text={clientCode} />
          </Fragment>
        );
      default:
        return <Fragment></Fragment>;
    }
  };

  return (
    <div className={classNames(mainStyles.resultContainer)}>
      {renderClientCodeComponent()}
      {error && (
        <div>
          <p id="clientCodeStatusError" className="text-alert-primary">
            {error}
          </p>
        </div>
      )}
    </div>
  );
};

const ClientCodeComponent = ({ text }) => (
  <table className="fields">
    <tbody>
      <tr>
        <th>
          <label>Client Code:</label>
        </th>
        <td id="clientCodeStatusInfo">{text}</td>
      </tr>
    </tbody>
  </table>
);
